export default __webpack_public_path__ + "static/media/scannerd.4fe2b81a.png";